/* tslint:disable */
/* eslint-disable */
/**
 * Mailbox API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const MailboxItemStatus = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
} as const;
export type MailboxItemStatus = typeof MailboxItemStatus[keyof typeof MailboxItemStatus];


export function instanceOfMailboxItemStatus(value: any): boolean {
    for (const key in MailboxItemStatus) {
        if (Object.prototype.hasOwnProperty.call(MailboxItemStatus, key)) {
            if (MailboxItemStatus[key as keyof typeof MailboxItemStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MailboxItemStatusFromJSON(json: any): MailboxItemStatus {
    return MailboxItemStatusFromJSONTyped(json, false);
}

export function MailboxItemStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MailboxItemStatus {
    return json as MailboxItemStatus;
}

export function MailboxItemStatusToJSON(value?: MailboxItemStatus | null): any {
    return value as any;
}

export function MailboxItemStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MailboxItemStatus {
    return value as MailboxItemStatus;
}

